/**
 * Feature flag configuration.
 *
 * FEATURE_FLAG_DEFAULTS  — values used when a flag has never been successfully
 *                          fetched (first-call failure or flag key not found).
 *
 * FEATURE_FLAG_REFRESH_INTERVAL_MS — how often the background poller re-fetches
 *                                    each active flag (default: 5 minutes).
 */

export const FEATURE_FLAG_DEFAULTS = {
  'widget-enabled':               true,
  'sponsored-questions-enabled':  true,
  'tooltip-enabled':              true,
  'scroll-refresh-enabled':       true,
  'amplitude-flag':               false,
  'feedback-enabled':               true,
  'is-feature-flag-enabled':         false,
};

export const FEATURE_FLAG_REFRESH_INTERVAL_MS = 1 * 60 * 1000; // 1 minute
